import React, { useEffect, useState } from 'react'
import { useFormik } from 'formik'
import { TrainerDetailFormValidations } from '../../../../../validations/TrainerDetailFormValidations'

import UserApi from '../../../../../../infrastructure/api/UserApi'
import { shallowEqual, useDispatch, useSelector } from 'react-redux'
import { IUserModel } from '../../../../../../models/responses/UserModel'
import { RootState } from '../../../../../../setup'
import { SaveChangesButton } from '../../../../../components/buttons/SaveChangesButton'
import { IUserClaimsRequestModel } from '../../../../../../models/requests/UserClaimsRequestModel'

import { FormikValidationError } from '../../../../../components/validations/FormikValidationError'
import { customSelectStyles } from '../../../../../helpers/ReactSelectHelper'
import {  SelectModel } from '../../../../../models/SelectModel'
import Select from 'react-select';
import TrainerApi from '../../../../../../infrastructure/api/TrainerApi'

import { ITrainerSettingsModel, trainerSettingsInitValues as initialValues } from '../../../../../../models/responses/TrainerModel'
import { ITrainerRequestModel } from '../../../../../../models/requests/TrainerRequestModel'
import CompanyApi from '../../../../../../infrastructure/api/CompanyApi'
import { ClaimTypeEnum } from '../../../../../../enums/ClaimTypeEnum'
import { UserModel } from '../../../../auth/models/UserModel'

const TrainerDetails: React.FC = () => {
  const [loading, setLoading] = useState(false)
  const [complete, setComplete] = useState(false)

  const dispatch = useDispatch()
  const user: IUserModel = useSelector<RootState>(({ account }) => account.selectedUser, shallowEqual) as IUserModel
  const userAuth: UserModel = useSelector<RootState>(({ auth }) => auth.user, shallowEqual) as UserModel

  const [trainerSettings, setTrainerSettings] = useState<ITrainerSettingsModel>(initialValues)

  const [isAvailableToCall, setAvailableToCall] = useState<boolean>(false)

  const [companies, setCompanies] = useState<SelectModel[]>([])
  const [selectedCompany, setSelectedCompany] = useState<SelectModel>()

  const formik = useFormik<ITrainerSettingsModel>({
    initialValues: trainerSettings,
    enableReinitialize: true,
    validationSchema: TrainerDetailFormValidations,
    onSubmit: (values) => {      
      setTimeout(() => {
        let model: ITrainerRequestModel = {
          id: user.id,
          isAvailableToCall: isAvailableToCall,
          companyId: selectedCompany?.value!
        }
        process(model)

      }, 500)
    },
  })

  async function process(model: ITrainerRequestModel) {
    try {

      await TrainerApi.UpdateTrainer(model);

      let modelClaims: IUserClaimsRequestModel = {
        id: user.id,
        claims: [
          { type: ClaimTypeEnum.CompanyId, value: selectedCompany?.value!.toString() || '' },
        ]
      }

      await UserApi.UpdateUserClaims(modelClaims);

      setComplete(true)
    } catch (error) {
      alert('Error: ' + error)
      setLoading(false)
    }
  }


  const init = async () => {
    if (userAuth.companyId) {
      var companies = await CompanyApi.GetSubCompaniesDictionary(userAuth.companyId)
      var dataParentCompanies: SelectModel[] = [
        ...companies.data.map((d) => ({
          value: d.id.toString(),
          label: d.name,
        })),
      ]
      setCompanies(dataParentCompanies)

      var companyId = user.details?.find(i => i.type == ClaimTypeEnum.CompanyId)?.value!! || '';
      if (companyId != null && companyId != '') {
        handleChangeCompany({
          value: companyId,
          label: dataParentCompanies.find(i => i.value == companyId)?.label
        })
      }
    }
    var responseTrainer = await TrainerApi.GetTrainerSettings(user.id)

    if (responseTrainer.data.id != undefined) {
      var trainer = responseTrainer.data;
      setTrainerSettings(trainer)
      setAvailableToCall(trainer.isAvailableToCall)
    }

  }

  useEffect(() => {
    if (user) {
      init();
    }
  }, [user])


  const handleChangeAvailableCall = () => {
    setAvailableToCall(!isAvailableToCall)
  }

  const handleChangeCompany = (e: any) => {
    setSelectedCompany(e);
  }


  return (
    <div className='card mb-5 mb-xl-10'>
      <div
        className='card-header border-0 cursor-pointer'
        role='button'
        data-bs-toggle='collapse'
        data-bs-target='#kt_account_profile_details'
        aria-expanded='true'
        aria-controls='kt_account_profile_details'
      >
        <div className='card-title m-0'>
          <h3 className='fw-bolder m-0'>Trainer Config</h3>
        </div>
      </div>

      <div id='kt_account_profile_details' className='collapse show'>
        <form onSubmit={formik.handleSubmit} noValidate className='form'>
          <div className='card-body border-top p-9'>

            <div className='row mb-6'>
              <label className='col-lg-4 mt-1 fw-bold fs-6'>Available To Call</label>
              <div className='col-lg-2 fv-row'>
                <div className='form-check form-check-lg form-switch form-check-custom form-check-solid'>
                  <input
                    {...formik.getFieldProps('isAvailableToCall')}
                    className='form-check-input h-30px w-50px'
                    type='checkbox'
                    name='isAvailableToCall'
                    checked={isAvailableToCall}
                    onClick={handleChangeAvailableCall}
                  />
                  <FormikValidationError touched={formik.touched.isAvailableToCall} error={formik.errors.isAvailableToCall} />
                </div>
              </div>
            </div>
            <div className='row mb-6'>
              <label className='col-lg-4 col-form-label fw-bold fs-6'>Company Section</label>
              <div className='col-lg-8 fv-row'>
                <Select
                  {...formik.getFieldProps('companyId')}
                  styles={customSelectStyles(true)}
                  onChange={(event) => handleChangeCompany(event)}
                  value={selectedCompany}
                  options={companies}
                />
                <FormikValidationError touched={formik.touched.companyId} error={formik.errors.companyId} />
              </div>
            </div>
          </div>

          <div className='card-footer d-flex justify-content-end py-6 px-9'>
            <SaveChangesButton
              loading={loading}
              setLoading={setLoading}
              complete={complete}
              setComplete={setComplete}
              valid={formik.isValid}
              submit={formik.isSubmitting}
              setSubmit={formik.submitForm} />
          </div>
        </form>
      </div >
    </div >
  )
}

export { TrainerDetails }
